import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-907c75d4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "extra-content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "请选择打赏金额", -1));
const _hoisted_3 = {
  class: "money-list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "土豪请随意", -1));
const _hoisted_6 = {
  class: "input-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $options.showPop,
    "onUpdate:show": _cache[3] || (_cache[3] = $event => $options.showPop = $event),
    round: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("i", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.closePopup && $options.closePopup(...args))
    }), _hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.extraRewardList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(['item', {
          'active': $data.checkedIndex == index
        }]),
        onClick: $event => $options.check(index)
      }, "￥" + _toDisplayString(item), 11, _hoisted_4);
    }), 128))]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_field, {
      modelValue: $data.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.value = $event),
      label: "￥",
      type: "number",
      "label-class": "labelClass",
      placeholder: "6.66",
      onFocus: $options.checkValue
    }, null, 8, ["modelValue", "onFocus"])]), _createElementVNode("div", {
      class: "submit",
      onClick: _cache[2] || (_cache[2] = (...args) => $options.submit && $options.submit(...args))
    }, "提交")])]),
    _: 1
  }, 8, ["show"]);
}